import { type PropsWithChildren, type ReactNode } from "react";

import { Stack, type SxProps, Typography } from "@mui/material";

export default function DataCell({
  sx,
  startDecorator,
  endDecorator,
  align = "left",
  tabular,
  noWrap,
  truncate,
  primary,
  secondary,
  invertOrder,
}: PropsWithChildren<{
  sx?: SxProps;
  startDecorator?: ReactNode;
  endDecorator?: ReactNode;
  align?: string;
  tabular?: boolean;
  noWrap?: boolean;
  truncate?: boolean;
  primary: ReactNode;
  secondary?: ReactNode;
  invertOrder?: boolean;
}>) {
  return (
    <Stack
      direction="row"
      sx={[
        {
          alignItems: "center",
          gap: 1,
        },
        {
          justifyContent: align === "left" ? "flex-start" : "flex-end",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {startDecorator}
      <Stack
        sx={{
          flexDirection: invertOrder ? "column-reverse" : "column",
          justifyContent: align === "left" ? "flex-start" : "flex-end",
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: 1.125,
            fontVariantNumeric: tabular ? "tabular-nums" : "initial",
            textWrap: noWrap ? "nowrap" : "initial",
            textAlign: align,
          }}
        >
          {primary}
        </Typography>
        {secondary && (
          <Typography
            sx={[
              {
                fontSize: 12,
                opacity: 0.6,
                lineHeight: 1.125,
                mt: 0.25,
                textWrap: noWrap ? "nowrap" : "initial",
                textAlign: align,
              },
              !!truncate && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              !!invertOrder && {
                mt: 0,
                mb: 0.25,
              },
            ]}
          >
            {secondary}
          </Typography>
        )}
      </Stack>
      {endDecorator}
    </Stack>
  );
}
